<script>
import { BaseIcon } from "@/components";
export default {
  name: "BaseInput",
  components: {
    BaseIcon,
  },
  props: {
    id: String,
    labelText: String,
    isDisabled: Boolean,
    inputType: String,
    allowDecimals: Boolean,
    noSpace: Boolean,
    noComma: Boolean,
    placeholder: String,
    value: [String, Number],
    withIcon: Boolean,
    icon: String,
    cssClass: String,
    min: {
      default: 0,
      type: Number,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
    step: {
      default: "any",
      type: String,
      required: false,
    },
    error: {
      type: Boolean,
      default: false,
      required: false,
    },
    isPrice: Boolean,
    refName: String,
  },
  data() {
    return {
      currentValue: this.value,
      currentType: this.inputType,
      isActive: false,
      iconEyeOpen: "eye-open",
      iconEyeClosed: "eye-closed",
    };
  },
  methods: {
    onInput(value) {
      this.currentValue = value;
      this.$emit("input", value);
    },
    onEnter(value) {
      this.$emit("enter", value);
    },
    onChange(value) {
      this.$emit("change", value);
    },
    onShowHidePassword() {
      this.currentType = this.currentType === "password" ? "text" : "password";
      this.isActive = this.isActive === "active" ? "" : "active";
    },
    checkNumber($event) {
      if (this.currentType === "number") {
        this.handleNumberInput($event);
      } else if (this.currentType === "text" && this.noSpace) {
        this.handleTextInput($event);
      }
    },
    handleNumberInput($event) {
      const ALLOWED_DOTS = 44;
      const NOT_ALLOWED_DOTS = 46;
      const codes = this.allowDecimals ? ALLOWED_DOTS : NOT_ALLOWED_DOTS;
      const keyCode = $event.keyCode || $event.which;

      if (keyCode < codes || keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    handleTextInput($event) {
      const keyCode = $event.keyCode || $event.which;

      if (keyCode === 32 || (this.noComma && keyCode === 44)) {
        $event.preventDefault();
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        this.currentValue = val;
        this.onChange(val);
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <div v-show="inputType !== 'hidden'" class="base-form-input">
    <label :for="id">{{ labelText }}</label>
    <input
      :type="currentType"
      :placeholder="placeholder"
      :name="id"
      :id="id"
      :value="currentValue"
      :class="[
        cssClass,
        error ? 'input-error' : '',
        isDisabled ? 'disabled' : '',
      ]"
      autocomplete="off"
      @input="onInput($event.target.value)"
      @keyup.enter="onEnter($event.target.value)"
      @keypress="checkNumber($event)"
      :min="min"
      :max="max"
      :step="step"
      :ref="refName"
      :disabled="isDisabled"
    />
    <base-icon v-if="withIcon" :name="icon"></base-icon>
    <button
      @click.prevent="onShowHidePassword"
      v-if="inputType == 'password'"
      :class="{ active: isActive }"
      id="showHidePass"
    >
      <base-icon v-if="isActive" :name="iconEyeOpen"></base-icon>
      <base-icon v-else :name="iconEyeClosed"></base-icon>
    </button>
  </div>
</template>
<style lang="scss" scoped>
.input-error {
  border: 1px solid red !important;
}
#showHidePass {
  right: 30px;
  bottom: 40px;
  position: absolute;
  border: none;
  background: transparent;
  outline: none;
}
</style>
